import { render, staticRenderFns } from "./SharingSummary.vue?vue&type=template&id=29d4bec8&scoped=true&"
import script from "./SharingSummary.vue?vue&type=script&lang=ts&"
export * from "./SharingSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d4bec8",
  null
  
)

export default component.exports